import { List } from 'components/order/list'
import { useEffect, useState } from 'react'
import { setModal, setOptions } from 'reducers/listReducer'
import { useDispatch, useSelector } from 'react-redux'
import { SORT_PRODUCT_REVIEW, TABLE_PRODUCT_REVIEW } from 'configs/reviews/configProductReview'
import { downloadFile, getAllQueryParams, getObjectName, getValueFromArray, setQueryParams } from 'utils/utils'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useFetch } from 'services/useFetch'
import { API_REVIEW } from 'services/apiReview'
import { Button } from 'avo-ui'
import icFilter from 'assets/images/ic-filter.svg'
import { RatingFilterModal } from 'components/reviews/all-review/RatingFilterModal'
import moment from 'moment'
import clsx from 'clsx'
import icFilterWhite from 'assets/images/ic-filter-white.svg'

export const ProductReviewContainer = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const { selectedValue, modal, query: INITIAL_DATA_FILTER } = useSelector((state) => state.listReducer)
    const {
        fetching: getProductReviewListApi,
        data: productReviewList,
        isLoading,
    } = useFetch(API_REVIEW.PRODUCT_REVIEW_LIST)
    const { fetching: exportProductReviewListApi, isLoading: isLoadingExport } = useFetch(
        API_REVIEW.EXPORT_PRODUCT_REVIEW,
    )
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER

    useEffect(() => {
        dispatch(
            setOptions({
                sort: SORT_PRODUCT_REVIEW,
                table: TABLE_PRODUCT_REVIEW,
                tab: [],
            }),
        )
    }, [])

    useEffect(() => {
        const newQuery = { ...query }
        if (newQuery?.ratings) newQuery['ratings'] = newQuery?.ratings?.split(',')
        getProductReviewListApi(newQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'ratings'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const onExport = () => {
        const payload = { product_ids: getValueFromArray(selectedValue?.selectedIds, 'id'), ...query }
        exportProductReviewListApi(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Product-Review-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            dispatch(setModal({ export: false }))
        })
    }

    const filter = () => {
        const values = query?.ratings?.split(',')
        return (
            <>
                <div className={'w-fit relative'}>
                    <Button
                        className={clsx(values?.length > 0 && '!bg-blue-90 !text-white')}
                        title={'Filter'}
                        icon={values?.length > 0 ? icFilterWhite : icFilter}
                        type={'outline'}
                        onClick={() => dispatch(setModal({ filter: true }))}
                    />
                    <div
                        className={`absolute -right-1 -top-3.5 py-1 px-2.5 text-white bg-blue-95 rounded-full ${values?.length > 0 ? 'block' : 'hidden'}`}
                    >
                        {values?.length}
                    </div>
                </div>
                {modal.filter && (
                    <RatingFilterModal
                        show={modal?.filter}
                        onHide={() => dispatch(setModal({ filter: false }))}
                        values={values}
                        onFilter={(value) => {
                            onChangeQuery({ ratings: value?.join(','), page: 1 })
                            dispatch(setModal({ filter: false }))
                        }}
                    />
                )}
            </>
        )
    }

    const props = {
        dataList: productReviewList?.data,
        query,
        isLoadingExport,
        onChangeQuery,
        isLoading,
        onExport,
        filter,
        isResetSelectedItem,
    }

    return <List {...props} />
}
